import module from 'empresa/module.js'
import template from './template.html'

export default class EmpresaCuentaDocumentosAgregarComponent {
  constructor ($fileSystem, EmpresaCuentaDocumentos) {
    this.$fileSystem = $fileSystem
    this.EmpresaCuentaDocumentos = EmpresaCuentaDocumentos
    this.idEmpresa = null
    this.idCuenta = null
    this.onClose = null
    this.agregando = false
    this.data = null
    this.documentos = [
      {id_tipo_documento: 5, descripcion: 'Contrato bancario'},
    ]
  }

  agregar () {
    if (this.agregando) return

    this.agregando = true

    this.EmpresaCuentaDocumentos.post(this.idEmpresa, this.idCuenta, this.data)
      .then((response) => (this.onClose({$event: {data: response.data}})))
      .finally(() => (this.agregando = false))
  }

  cerrar () {
    this.onClose()
  }

  seleccionar (id_tipo_documento) {
    this.$fileSystem.select(false, 'application/pdf')
      .then((files) => {
        this.data = {id_tipo_documento, file: files[0]}

        this.agregar()
      })
  }
}

module.component('empresaCuentaDocumentosAgregar', {
  controller: EmpresaCuentaDocumentosAgregarComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idCuenta: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/cuenta/documentos/agregar/component.js